/* eslint-disable react/forbid-prop-types */
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import { cityOptionObj, stateOptionsObj } from '../../../api/stateCityUtils';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import AppButton from '../../../shared/components/app-button/AppButton';
import { getUserAgentId } from '../../../shared/helper-utils/localStorage';
import { addStaff, updateStaff } from '../../../api/profileApi';

function AddOrEditStaff({ selectedStaff, onLoading, onSave }) {
  // const stateOptionsRef = useRef(stateOptionsObj);
  // const cityOptionsRef = useRef(cityOptionObj);

  // const countryOptionsRef = useRef([
  //   {
  //     label: 'India',
  //     value: 'India',
  //   },
  // ]);
  const statusRef = useRef([
    {
      label: 'Active',
      value: 'active',
    },
    {
      label: 'Inactive',
      value: 'inactive',
    },
    {
      label: 'Suspended',
      value: 'suspended',
    },
  ]);

  const salutationOptionsRef = useRef([
    {
      label: 'Mr',
      value: 'Mr',
    },
    {
      label: 'Mrs',
      value: 'Mrs',
    },
    {
      label: 'Ms',
      value: 'Ms',
    },
  ]);
  const [staff, setStaff] = useState({
    userid: '',
    salutation: '',
    first_name: '',
    last_name: '',
    contact_email: '',
    mobile_number: '',
    contact_number: '-',
    address1: '-',
    address2: '-',
    city: '-',
    state: '-',
    country: '-',
    pincode: '-',
  });

  useEffect(() => {
    if (selectedStaff) {
      setStaff(selectedStaff);
    }
  }, [selectedStaff]);

  const [isValidationError, setIsValidationError] = useState(false);

  const handleCreate = async () => {
    if (
      staff.salutation === '' ||
      staff.first_name === '' ||
      staff.last_name === '' ||
      staff.contact_email === '' ||
      staff.mobile_number === '' ||
      staff.userid === ''
    ) {
      setIsValidationError(true);
    } else if (
      staff.profileid !== undefined &&
      staff.profileid !== '' &&
      staff.status === ''
    ) {
      setIsValidationError(true);
    } else {
      setIsValidationError(false);
      onLoading(true);
      let response = {};
      if (staff.profileid === undefined || staff.profileid === '') {
        staff.agentid = getUserAgentId();
        response = await addStaff(staff);
      } else {
        response = await updateStaff(staff);
      }
      onSave(response);
      onLoading(false);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setStaff((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSelectChange = (value, name) => {
    if (value !== null) {
      setStaff((prevState) => ({
        ...prevState,
        [name]: value.value,
      }));
    } else {
      setStaff((prevState) => ({
        ...prevState,
        [name]: '',
      }));
    }
  };

  return (
    <div>
      <Row>
        <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
          <AppSelect
            required
            selectWidth="100"
            label="Select Title"
            name="salutation"
            id="salutation"
            placeholder=""
            errorText={isValidationError ? 'Please select title' : ''}
            options={salutationOptionsRef.current}
            selectedValue={staff.salutation}
            onSelect={handleSelectChange}
          />
        </Col>
        <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
          <AppTextInput
            required
            value={staff.first_name}
            onChange={handleChange}
            name="first_name"
            errorText={isValidationError ? 'Please enter first name' : ''}
            id="first_name"
            label="First name"
          />
        </Col>
        <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
          <AppTextInput
            required
            value={staff.last_name}
            onChange={handleChange}
            name="last_name"
            errorText={isValidationError ? 'Please enter last name' : ''}
            id="last_name"
            label="Last name"
          />
        </Col>
        <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
          <AppTextInput
            required
            value={staff.contact_email}
            onChange={handleChange}
            errorText={isValidationError ? 'Please enter email' : ''}
            name="contact_email"
            id="contact_email"
            label="Email"
          />
        </Col>
        <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
          <AppTextInput
            required
            value={staff.mobile_number}
            onChange={handleChange}
            name="mobile_number"
            type="number"
            errorText={isValidationError ? 'Please enter mobile number' : ''}
            id="mobile_number"
            label="Mobile Number"
          />
        </Col>
        <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
          <AppTextInput
            required
            value={staff.userid}
            onChange={handleChange}
            name="userid"
            type="text"
            errorText={isValidationError ? 'Please enter User Id' : ''}
            id="userid"
            label="User Id"
            disabled={selectedStaff}
          />
        </Col>
        {staff.profileid !== '' && staff.profileid !== undefined && (
          <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
            <AppSelect
              required
              selectWidth="100"
              label="Select Status"
              name="status"
              id="status"
              placeholder=""
              errorText={isValidationError ? 'Please select status' : ''}
              options={statusRef.current}
              selectedValue={staff.status}
              onSelect={handleSelectChange}
            />
          </Col>
        )}
        {/* <Col lg={12} m={12} sm={12} xs={12} className="mb-3">
          <h5>Address Details</h5>
        </Col>
        <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
          <AppTextInput
            required
            name="address1"
            id="address1"
            label="Address 1"
            errorText={isValidationError && 'Please enter address1'}
            value={staff.address1}
            onChange={handleChange}
          />
        </Col>
        <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
          <AppTextInput
            name="address2"
            id="address2"
            label="Address 2"
            errorText={isValidationError && 'Please enter address2'}
            value={staff.address2}
            onChange={handleChange}
          />
        </Col>
        <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
          <AppTextInput
            required
            type="number"
            name="pincode"
            id="pincode"
            errorText={isValidationError && 'Please enter PIN code'}
            label="Pincode"
            value={staff.pincode}
            onChange={handleChange}
          />
        </Col>
        <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
          <AppSelect
            selectWidth="100"
            label="Select City"
            className="traveller-input"
            name="city"
            id="city"
            required
            placeholder=""
            errorText={isValidationError && 'Please select city'}
            options={cityOptionsRef.current}
            selectedValue={staff.city}
            onSelect={handleSelectChange}
          />
        </Col>
        <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
          <AppSelect
            selectWidth="100"
            label="Select State"
            className="traveller-input"
            name="state"
            id="state"
            required
            placeholder=""
            errorText={isValidationError ? 'Please select state' : ''}
            options={stateOptionsRef.current}
            selectedValue={staff.state}
            onSelect={handleSelectChange}
          />
        </Col>
        <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
          <AppSelect
            selectWidth="100"
            label="Select Country"
            className="traveller-input"
            name="country"
            id="country"
            required
            placeholder=""
            errorText={isValidationError && 'Please select country'}
            options={countryOptionsRef.current}
            selectedValue={staff.country}
            onSelect={handleSelectChange}
          />
        </Col>
        <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
          <AppTextInput
            required
            name="contact_number"
            id="contact_number"
            label="Contact Number"
            errorText={isValidationError && 'Please enter contact number'}
            value={staff.contact_number}
            onChange={handleChange}
          />
        </Col>
        <Col lg={12} md={12} sm={12} xs={12} /> */}
        <Col lg={4} md={4} sm={4} xs={12} className="mb-3">
          <AppButton
            btnText={
              staff.profileid === undefined ? 'Create Staff' : 'Update Staff'
            }
            className="w-100"
            onClick={handleCreate}
          />
        </Col>
        <Col lg={4} />
      </Row>
    </div>
  );
}
AddOrEditStaff.defaultProps = {
  selectedStaff: undefined,
};

AddOrEditStaff.propTypes = {
  selectedStaff: PropTypes.object,
  onLoading: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default AddOrEditStaff;
